import React from "react";

import { isEmpty, partition } from "lodash/fp";

import { Stack } from "@mui/material";

import TeamsListRow from "./TeamsListRow";
import { TeamTimekeeperData, TeamsListData, TeamNumberData } from "./types";
import { getPropertyToSortBy } from "./utils";

const getSortedTeams = ({
  teams,
  propertyToSortBy,
}: {
  teams: TeamTimekeeperData[];
  propertyToSortBy: keyof TeamNumberData;
}): TeamTimekeeperData[] => {
  return [...teams].sort((a, b) => {
    const aValue = a[propertyToSortBy];
    const bValue = b[propertyToSortBy];
    if (aValue === bValue) {
      return b.name > a.name ? -1 : 1;
    }
    return bValue - aValue;
  });
};

const TeamsList = ({
  workspaceAverages,
  teams,
  metric,
  currentTab,
}: TeamsListData) => {
  const propertyToSortBy = getPropertyToSortBy(currentTab, metric);

  const policyThreshold = workspaceAverages[propertyToSortBy];

  const sortedTeams = getSortedTeams({
    teams,
    propertyToSortBy,
  });

  const workspaceAverageTeam = {
    id: "AVERAGE",
    name: "Workspace Avg",
    ...workspaceAverages,
  };

  const [outOfPolicyTeams, inPolicyTeams] = partition(
    (team) => team[propertyToSortBy] > policyThreshold,
    sortedTeams
  );

  return (
    <Stack
      sx={{
        width: "100%",
        minWidth: "55%",
        height: "205px",
        overflow: "auto",
      }}
    >
      {outOfPolicyTeams.map((team, i) => (
        <TeamsListRow
          key={team.id}
          inPolicy={false}
          metric={metric}
          propertyToSortBy={propertyToSortBy}
          team={team}
          withDivider={i > 0}
        />
      ))}
      <TeamsListRow
        isAverage
        metric={metric}
        propertyToSortBy={propertyToSortBy}
        team={workspaceAverageTeam}
        withDivider={!isEmpty(outOfPolicyTeams)}
      />
      {inPolicyTeams.map((team) => (
        <TeamsListRow
          key={team.id}
          inPolicy
          metric={metric}
          propertyToSortBy={propertyToSortBy}
          team={team}
          withDivider
        />
      ))}
    </Stack>
  );
};
export default TeamsList;
